import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { HomeComponent } from '@views/home/home.component';
import { NotfoundComponent } from '@views/notfound/notfound.component';

const routes: Routes = [
    { path: '', component: HomeComponent},
    { path: '**', component: NotfoundComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
